module.exports = __webpack_public_path__ + "img/air-max-97-womens-shoe.65305d17.png";